module.exports = __webpack_public_path__ + "static/media/detail.52afdf94.svg";